import gql from 'graphql-tag';
import query from '../../../routes/site-admin/feeCategory/feeCategoryList/getAllFeeCategories.graphql';
import showToaster from '../../../helpers/showToaster';

const mutation = gql`
  mutation(
    $id: Int
    $name: String!
    $type: String!
    $value: Float!
    $currency: String
    $scope: String
    $applyOrder: Int
    $isActive: Boolean
    $payTo: String
  ) {
    saveFeeCategory(
      id: $id
      name: $name
      type: $type
      value: $value
      currency: $currency
      scope: $scope
      applyOrder: $applyOrder
      isActive: $isActive
      payTo: $payTo
    ) {
      status
      errorMessage
      id
    }
  }
`;

export function saveFeeCategory(input) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: input,
        refetchQueries: [{ query }],
      });

      if (data && data.saveFeeCategory && data.saveFeeCategory.status === 200) {
        showToaster({
          messageId: 'saveFeeCategory',
          toasterType: 'success',
          requestContent: input && input.id ? true : false,
        });
        return { status: 200, id: data.saveFeeCategory.id };
      }
      const err =
        (data && data.saveFeeCategory && data.saveFeeCategory.errorMessage) ||
        'Could not save fee category';
      showToaster({
        messageId: 'feeCategoryError',
        toasterType: 'error',
        requestContent: err,
      });
      return { status: 400, errorMessage: err };
    } catch (error) {
      showToaster({
        messageId: 'feeCategoryError',
        toasterType: 'error',
        requestContent: error && error.message,
      });
      return { status: 400, errorMessage: error && error.message };
    }
  };
}

export default saveFeeCategory;
